import { useCallback, useEffect, useState } from 'react';
import { dispatcher } from 'dispatcher';

import { ITranslateMethod } from '@core/js/hooks/i18n/types';

import { VALIDATION_EVENTS } from '@interlayer/js/app/hooks/useValidationRules/constants';

export const useCheckMembership = (t: ITranslateMethod, isBlocked?: boolean) => {
    const [memberShipsWithError, setMemberShipWithError] = useState<string[]>([]);

    useEffect(() => {
        if (isBlocked) {
            return;
        }

        const handlerSetMemberShipWithError = (membershipNumber: string) => {
            setMemberShipWithError((prevState) => [...prevState, membershipNumber]);
        };

        dispatcher.listen(VALIDATION_EVENTS.SET_MEMBERSHIP_ERROR, handlerSetMemberShipWithError);

        return () => {
            dispatcher.removeListener(VALIDATION_EVENTS.SET_MEMBERSHIP_ERROR, handlerSetMemberShipWithError);
        };
    }, [isBlocked]);

    return useCallback((value: string) => {
        if (memberShipsWithError.includes(value)) {
            return [t('membership.notFound')];
        }
    }, [memberShipsWithError, t]);
};
